import { render, staticRenderFns } from "./AuthTokensTable.vue?vue&type=template&id=63f35738&scoped=true"
import script from "./AuthTokensTable.vue?vue&type=script&lang=js"
export * from "./AuthTokensTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f35738",
  null
  
)

export default component.exports